/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Chatting: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M22.9996 6H19.9996V14C19.9996 14.5304 19.7889 15.0391 19.4138 15.4142C19.0388 15.7893 18.5301 16 17.9996 16H11.6876L7.84863 19H13.9996L19.9996 23V19H22.9996C23.2648 19 23.5192 18.8946 23.7067 18.7071C23.8943 18.5196 23.9996 18.2652 23.9996 18V7C23.9996 6.73478 23.8943 6.48043 23.7067 6.29289C23.5192 6.10536 23.2648 6 22.9996 6Z'
      fill='currentColor'
    />
    <path
      d='M17 1H1C0.734784 1 0.48043 1.10536 0.292893 1.29289C0.105357 1.48043 0 1.73478 0 2L0 13C0 13.2652 0.105357 13.5196 0.292893 13.7071C0.48043 13.8946 0.734784 14 1 14H4V19.469L11 14H17C17.2652 14 17.5196 13.8946 17.7071 13.7071C17.8946 13.5196 18 13.2652 18 13V2C18 1.73478 17.8946 1.48043 17.7071 1.29289C17.5196 1.10536 17.2652 1 17 1Z'
      fill='currentColor'
    />
  </React.Fragment>
)
